import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=86ecac6c&lang=pug&"
import script from "./Information.vue?vue&type=script&lang=ts&"
export * from "./Information.vue?vue&type=script&lang=ts&"
import style0 from "./Information.vue?vue&type=style&index=0&id=86ecac6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports